module.exports = __webpack_public_path__ + "img/gray-explain-in-detail.d2c58e74.png";